module.exports = __webpack_public_path__ + "images/team/saubere_filme_team_foto_agnes.jpg";